import { defineMessages } from 'react-intl'

export default defineMessages({
  pending: {
    id: 'components.AiFileChip.pending',
    defaultMessage: 'AI-generated: embedding the disclosure…',
  },
  tagged: {
    id: 'components.AiFileChip.tagged',
    defaultMessage: 'AI-generated: disclosure embedded',
  },
  tagged_unsigned: {
    id: 'components.AiFileChip.taggedUnsigned',
    defaultMessage: 'AI-generated: disclosure embedded, signature pending',
  },
  unsupported: {
    id: 'components.AiFileChip.unsupported',
    defaultMessage: 'AI-generated: this format cannot carry an embedded disclosure',
  },
  failed: {
    id: 'components.AiFileChip.failed',
    defaultMessage: 'AI-generated: embedding the disclosure failed, see the order log',
  },
  markUploadsAsAi: {
    id: 'components.AiFileChip.markUploadsAsAi',
    defaultMessage: 'Mark uploads as AI-generated',
  },
  markAsAi: {
    id: 'components.AiFileChip.markAsAi',
    defaultMessage: 'Mark as AI-generated',
  },
  unmarkAsAi: {
    id: 'components.AiFileChip.unmarkAsAi',
    defaultMessage: 'Unmark as AI-generated',
  },
  confirmUnmark: {
    id: 'components.AiFileChip.confirmUnmark',
    defaultMessage: 'This removes the AI disclosure from the delivered file. Continue?',
  },
  saved: {
    id: 'components.AiFileChip.saved',
    defaultMessage: 'AI flag saved. The file is being updated.',
  },
})
